import React from 'react';

import Timelapse from '../Video/Timelapse.mp4'
import Kobe from '../Video/Kobe.mp4'
import Boat from '../Video/Boat.mp4'
import { Paragraph, Pane, Heading } from 'evergreen-ui'


function Gallery(props) {
  return(
    <div className="App">
          <video
            autoPlay
            loop
            muted
            style={{
              position: "absolute",
              width: "100%",
              left: "50%",
              top: "50%",
              height: "100%",
              objectFit: "cover",
              transform: "translate(-50%, -50%)",
              zIndex: "-1"
            }}
          >
        <source src ={Timelapse} type="video/mp4" />


        </video>
        <Pane
        background="transparent"
        elevation={0}
        float="left"
        width={500}
        height={150}
        margin={299}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        >
          <Paragraph style={{color: 'goldenrod'}} marginTop="default">
          <Heading height={600} style={{color: 'goldenrod'}} size={800}>Timelapse Art
          </Heading>
          </Paragraph>

            </Pane>
            <Pane
            background="transparent"
            elevation={0}
            float="right"
            width={500}
            height={150}
            margin={300}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            >
              <Paragraph style={{color: 'goldenrod'}} marginTop="default">
              <Heading height={600} style={{color: 'goldenrod'}} size={700}>This timelapse was a project focused on editing skills and Premiere Pro literacy
              </Heading>
              </Paragraph>

                </Pane>


              <video
                autoPlay
                loop
                muted
                style={{
                  position: "absolute",
                  width: "100%",
                  left: "50%",
                  top: "150%",
                  height: "100%",
                  objectFit: "cover",
                  transform: "translate(-50%, -50%)",
                  zIndex: "-1"
                }}
              >
            <source src ={Kobe} type="video/mp4" />

            </video>
            <Pane
            background="transparent"
            elevation={0}
            float="right"
            width={500}
            height={150}
            margin={300}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            >
              <Paragraph   marginTop="default">
              <Heading height={1800} style={{color: 'goldenrod'}} size={800}>Kobe Bryant Found Footage
              </Heading>
              </Paragraph>

                </Pane>
                <Pane
                background="transparent"
                elevation={0}
                float="left"
                width={500}
                height={0}
                margin={300}
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                >
                  <Paragraph style={{color: 'goldenrod'}} marginTop="default">
                  <Heading height={1500} style={{color: 'goldenrod'}} size={700}>The goal for this video was to find previously recorded footage and edit together video to convey a message
                  </Heading>
                  </Paragraph>

                    </Pane>

            <video
              autoPlay
              loop
              muted
              style={{
                position: "absolute",
                width: "100%",
                left: "50%",
                top: "250%",
                height: "100%",
                objectFit: "cover",
                transform: "translate(-50%, -50%)",
                zIndex: "-1"
              }}
            >
          <source src ={Boat} type="video/mp4" />


          </video>
          <Pane

          background="transparent"
          elevation={0}
          float="left"
          width={500}
          height={100}
          margin={300}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          >



          <div>
            <Paragraph height={2500} marginTop="default" >
            <Heading style={{color: 'goldenrod'}} size={800}>Muesem Level
            </Heading>
            </Paragraph>
            </div>
              </Pane>

              <Pane
              background="transparent"
              elevation={0}
              float="right"
              width={500}
              height={0}
              margin={300}
              display="flex"
              justifyContent="center"
              alignItems="center"
              flexDirection="column"
              >
                <Paragraph style={{color: 'goldenrod'}} marginTop="default">
                <Heading height={2200} style={{color: 'goldenrod'}} size={700}>The muesem level was created from scratch using Unity as well as 3Ds Max to create a small enviroment
                </Heading>
                </Paragraph>

                  </Pane>

              </div>

  );
};
export default Gallery;
